import { AxiosError } from 'axios';
import { useState } from 'react';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import { dashboardDataActions } from '../../../redux/slices/dashboardDataSlice';
import { useAppDisPatch } from '../../../redux/store';
import useHttps from '../../useHttps';

const useDashboardData = () => {
    const request = useHttps();
    const dispatch = useAppDisPatch();
    const [loading, setLoading] = useState(false);

    const onDashboardDataError = (err: AxiosError<ErrorHttpResponse>) => {
        // console.error(err?.response?.data?.message ?? 'Something went wrong while retrieving dashboard data');
    };

    const onDashboardDataSuccess = ({
        data,
        message,
    }: SuccessHttpResponse<any>) => {
        dispatch(dashboardDataActions.setDashboardData(data));
    };

    const dashboardData = async () => {
        const url: HttpConfig = {
            url: `ba/v1/dashboard/metrics`,
            method: 'get',
        };

        return request(url, onDashboardDataSuccess, setLoading, onDashboardDataError);
    };

    return { dashboardData, loading };
};

export default useDashboardData;
